
export const MOBILE_WIDTH_CUTOFF = 640;

export const isMobileView = windowWidth => windowWidth < MOBILE_WIDTH_CUTOFF;
